export default "__VITE_ASSET__C0tCIU3b__"